import React from 'react';
import { StateLog } from '../../../models/StateLog';
import { OrderInTransport } from '../../../services/Orders/GetOrdersInTransport/OrderInTransport';
import { Pagination } from '../../../common-components/Pagination/Pagination';
import { WaitingIcon } from '../../../common-components/WaitingIcon/WaitingIcon';
import { OrdersInTransport } from '../OrdersInTransport/OrdersInTransport';
import { Container } from './styles';

interface IPaginatedOrdersInTransportListProps {
  currentPage: number;
  currentPageSize: number;
  amountOfPages: number;
  totalAmount: number;
  ordersInTransport?: OrderInTransport[];
  filterAreaHeight: number;
  pageSize: number;
  changePageSize: (pageSize: number) => void;
  changePage: (page: number) => void;
  filtering?: boolean;
  newStateOrder?: (newState: StateLog) => void;
  refreshRow?: (orderInTransport?: OrderInTransport | null) => void;
}

const PaginatedOrdersInTransportList: React.FC<IPaginatedOrdersInTransportListProps> = ({
  currentPage,
  currentPageSize,
  amountOfPages,
  totalAmount,
  ordersInTransport,
  filterAreaHeight,
  pageSize,
  changePageSize,
  changePage,
  filtering,
  newStateOrder,
  refreshRow
}) => {

  if (filtering) return <WaitingIcon />;

  return (
    <Container>
      {ordersInTransport && ordersInTransport.length > 0 ?
        <OrdersInTransport
          ordersInTransport={ordersInTransport}
          filterAreaHeight={filterAreaHeight}
          newStateOrder={newStateOrder}
          refreshRow={refreshRow}
        />
        : null}
      <Pagination
        currentPage={currentPage}
        currentPageSize={currentPageSize}
        amountOfPages={amountOfPages}
        totalAmount={totalAmount}
        pageSize={pageSize}
        changePageSize={(size) => changePageSize(size)}
        changePage={(page) => changePage(page)}
      />
    </Container>
  );
}

export { PaginatedOrdersInTransportList };